import { Link } from "react-router-dom";
import { SubscribeForm } from "@/components/ui/forms";

export default function SubscribeBand() {
  return (
    <section className="container-page mt-14 md:mt-20">
      <div className="overflow-hidden rounded-lg bg-secondary-100">
        <div className="grid grid-cols-1 gap-8 p-7 md:p-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="label-caps text-accent-700">
              <i className="ri-mail-send-line"></i>
              每日瓜讯
            </span>
            <h2 className="mt-2 font-heading text-2xl font-extrabold leading-snug text-foreground-950 md:text-3xl">
              每天三分钟，
              <br className="hidden md:block" />
              把最新热瓜一次看完
            </h2>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-700">
              不想错过新的圈内爆料？订阅每日瓜讯，我们会把当天编辑部筛选过的重点信源内容，整理成一份轻量邮件发给你。
            </p>
            <ul className="mt-5 space-y-2 text-sm text-foreground-700">
              {[
                "只发重点：不灌水、不重复",
                "来源标注：每条都写明圈内信源",
                "随时退订：一个按钮即可取消",
              ].map((t) => (
                <li key={t} className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-accent-600"></i>
                  {t}
                </li>
              ))}
            </ul>
            <div className="mt-6 flex flex-wrap items-center gap-4">
              <Link
                to="/category/zhiqing"
                className="text-sm font-semibold text-primary-600 hover:text-primary-700"
              >
                先逛逛知情者密档
                <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
          </div>
          <div className="rounded-lg bg-background-50 p-6 md:p-7">
            <p className="mb-4 text-sm font-medium text-foreground-800">
              立即订阅，今日热瓜随邮件送达 👇
            </p>
            <SubscribeForm />
          </div>
        </div>
      </div>
    </section>
  );
}